import { Box } from '@mui/material';
import { vipPassesRewardSrc } from '../../assets/bazzar';

export default function VipPassTitle() {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 400,
        mx: 'auto',
        my: { xs: 0, md: 2.2 },
      }}
    >
      <Box
        component="img"
        src={vipPassesRewardSrc}
        alt="VIP Passes"
        sx={{
          width: '100%',
          aspectRatio: '401 / 228',
          display: 'block',
          objectFit: 'contain',
        }}
      />
    </Box>
  );
}
